import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_USER + '/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_USER + '/update_status',
    method: 'post',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_USER + '/detail',
    method: 'get',
    params: data
  })
}

export function getListOutlet() {
  return request({
    url: process.env.BASE_URL_REPORT + '/store',
    method: 'get',
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_USER + '/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_USER + '/update',
    method: 'post',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/user.js